import StatisticButton from './StatisticButton';

export default StatisticButton;